import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import { Input } from "../../../lib/Input";
import { Time } from "../../../lib/Time";
import Vector2 from "../../../math/Vector2";
import DaggerMineBehavior from "../../DaggerMineBehavior";
import Gun from "../../Gun";
import Player from "../../Player";

export default class DaggerMines extends Gun {
    constructor(player: Player) {
        super(player, {
            damage: 200,
            fireRate: 1,
            reloadTime: 10,
            bulletSpeed: 64,
            magSize: 3,
            mouseTrigger: 2
        })
    }

    onShoot(): void {
            const centerSpawnPos = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size + 4));
            const vel = this.player.velocity.add(this.player.transform.forward.scale(this.bulletSpeed));
    
            const [, mine] = this.player.engine.NewGameObjectWithScript<DaggerMineBehavior>(DaggerMineBehavior);
            mine.team = this.player.team;
            mine.ownerName = this.player.name;
            mine.damage = this.damage;
            mine.transform.position = centerSpawnPos;
            mine.velocity = vel.clone();
    
            this.player.engine.sendCreatePacket(mine.gameObject, {
                type: "DAGGER_MINE",
                values: [
                    {
                        key: "team",
                        value: this.player.team || "",
                        type: PacketValueSerialType.String
                    },
                    {
                        key: "velocity",
                        value: mine.velocity,
                        type: PacketValueSerialType.Vector2
                    },
                    {
                        key: "ownerName",
                        value: this.player.name,
                        type: PacketValueSerialType.String
                    },
                    {
                        key: "damage",
                        value: this.damage,
                        type: PacketValueSerialType.UInt
                    },
                ]
            })
        }

    Shoot() {
        
        if (this.bullets === 0 || this.fireTimer > 0) return;
        
        this.bullets--;
        this.onShoot();
        this.fireTimer = 1/this.fireRate;
        if (this.reloadTimer === 0) this.reloadTimer = this.reloadTime;
        
    }

    Update(): void {
        if (!this.player.isOwner || this.player.isDead) return;

        if (this.fireTimer > 0) {
            this.fireTimer -= Time.deltaTime;

            if (this.fireTimer <= 0) this.fireTimer = 0;
        }

        if (this.mouseTrigger != undefined && Input.GetMouseButton(this.mouseTrigger)) {
            
            this.Shoot();
        }

        if (this.bullets < this.magSize && this.reloadTimer > 0) {
            this.reloadTimer -= Time.deltaTime;

            if (this.reloadTimer <= 0) {
                this.bullets++;

                if (this.bullets < this.magSize) {
                    this.reloadTimer = this.reloadTime;
                } else this.reloadTimer = 0;
            }
        }
    }

    Draw(yOffset: number): void {
        const ctx = this.player.ctx;
        const engine = this.player.engine;

        for (let i = 0; i < this.magSize; i++) {
            ctx.fillStyle = this.bullets > i ? '#ffffff' : '#ffffff55';
            engine.FillRect(this.player.transform.position.add(new Vector2(25 - 4 - 6*i, this.player.size + yOffset)), new Vector2(2, 4));
        }
    }
}